import { render, staticRenderFns } from "./subject_setting.vue?vue&type=template&id=579f772c&scoped=true&"
import script from "./subject_setting.vue?vue&type=script&lang=js&"
export * from "./subject_setting.vue?vue&type=script&lang=js&"
import style0 from "./subject_setting.vue?vue&type=style&index=0&id=579f772c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579f772c",
  null
  
)

export default component.exports